import { Modal } from "react-bootstrap";
import btnClose from "../../../assets/images/svg/close_modal_icon.svg";
import { useEffect, useState } from "react";

import { ErrorToast } from "../../../shared";
import CustomValuesHook from "../../../Hooks/customValuesHook";
import {
  downloadKeyhanRequest,
  getKeyhanRequest,
} from "../../../api/requestAxios/keyhanRequest";

const KeyhanErrorModal = ({ setId, id }) => {
  const [value, setValue] = CustomValuesHook({
    loading: false,
    data: {},
    titlel: "",
    downloadLoading: false,
  });

  useEffect(() => {
    if (id) {
      getKeyhanLog();
    }
  }, [id]);

  const getKeyhanLog = async () => {
    setValue({ loading: true });
    try {
      const data = await getKeyhanRequest(id);
      if (data?.data) {
        setValue({
          loading: false,
          data: data?.data,
          title: data?.data?.responseDetail?.errorMessage,
        });
      }
    } catch (err) {
      setValue({ loading: false });
      ErrorToast(err);
    }
  };
  const downloadKeyhanLog = async () => {
    setValue({ downloadLoading: true });
    try {
      const data = await downloadKeyhanRequest(id);
      if (data?.data) {
        const blob = new Blob([data.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "keyhanLog.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        setValue({ downloadLoading: false });
      }
    } catch (err) {
      setValue({ downloadLoading: false });
      ErrorToast(err);
    }
  };

  const handleClose = () => {
    setId("");
  };

  const downloadLog = () => {
    downloadKeyhanLog();
  };

  function ObjectRenderer({ object }) {
    if (object && typeof object === "object") {
      return (
        <div>
          {Object.entries(object).map(([key, value]) => (
            <div
              className="d-flex justify-content-start align-items-start"
              dir="ltr"
              key={key}
            >
              {typeof value === "object" && value !== null ? (
                <div
                  className="d-flex justify-content-start align-items-start"
                  dir="ltr"
                >
                  <strong>{key}:</strong>
                  <br />
                  <div
                    className="d-flex justify-content-start align-items-start"
                    dir="ltr"
                  >
                    {" "}
                    <ObjectRenderer object={value} />
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex justify-content-start align-items-start"
                  dir="ltr"
                >
                  <strong>{key}:</strong>
                  <span>
                    {" "}
                    {key !== "isFree"
                      ? value !== null && value !== ""
                        ? value
                        : "---"
                      : value
                      ? "true"
                      : "false"}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <Modal
      show={id ? true : false}
      onHide={handleClose}
      animation={true}
      dir="rtl"
      className="keyhan-modal"
    >
      <Modal.Header>
        <Modal.Title style={{ fontSize: "16px" }}>
          <div className="d-flex justify-content-between w-100">
            دلیل تایید عدم فعالسازی
            <img onClick={handleClose} src={btnClose} />
          </div>

          <div className="mt-8">
            <br />
            <div
              className="d-flex justify-content-start"
              dir={"ltr"}
              style={{ textAlign: "justify" }}
            >
              {value?.title}{" "}
            </div>
            <br />
            <span>نتیجه‌ی کیهان :</span>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="keyhan-modal-content-view">
        {value?.loading && (
          <div
            className="spinner-border"
            role="status"
            aria-hidden="true"
          ></div>
        )}

        {!value?.loading && (
          <div>
            <div>{<ObjectRenderer object={value?.data} />}</div>
            <br />
            <br />
            <div className=" d-flex justify-content-center align-items-center ">
              <div className="d-flex justify-content-between align-items-center footer-keyhan-log">
                <span
                  className="download-keyhan-log"
                  onClick={() => downloadLog()}
                >
                  {value?.downloadLoading ? (
                    <div
                      className="spinner-border"
                      role="status"
                      aria-hidden="true"
                    ></div>
                  ) : (
                    "دانلود لاگ کیهان"
                  )}
                </span>
                <button
                  className="btn btn-success "
                  onClick={() => {
                    handleClose();
                  }}
                >
                  بستن
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default KeyhanErrorModal;
